import { render, staticRenderFns } from "./Post_Text_Username.vue?vue&type=template&id=b4503158&scoped=true&"
import script from "./Post_Text_Username.vue?vue&type=script&lang=js&"
export * from "./Post_Text_Username.vue?vue&type=script&lang=js&"
import style0 from "./Post_Text_Username.vue?vue&type=style&index=0&id=b4503158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4503158",
  null
  
)

export default component.exports